import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledDescription = styled(Flex)`
    padding: 9px 0;
    margin-top: -24px;
    margin-right: 50px;
`;
